"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
var _mixinExecutionListener = _interopRequireDefault(require("@/libs/flowable/common/mixinExecutionListener"));
var _parseElement = require("@/libs/flowable/common/parseElement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  mixins: [_mixinPanel.default, _mixinExecutionListener.default],
  data: function data() {
    return {
      formData: {}
    };
  },
  computed: {
    formConfig: function formConfig() {
      return {
        inline: false,
        item: [{
          xType: 'input',
          name: 'id',
          label: '节点 id',
          rules: [{
            required: true,
            message: 'Id 不能为空'
          }]
        }, {
          xType: 'input',
          name: 'name',
          label: '节点名称'
        }, {
          xType: 'input',
          name: 'documentation',
          label: '节点描述'
        }, {
          xType: 'slot',
          name: 'executionListener',
          label: '执行监听器'
        }, {
          xType: 'input',
          name: 'conditionExpression',
          label: '跳转条件'
        }, {
          xType: 'input',
          name: 'skipExpression',
          label: '跳过表达式'
        }]
      };
    }
  },
  watch: {
    'formData.conditionExpression': function formDataConditionExpression(val) {
      if (val) {
        var newCondition = this.modeler.get('moddle').create('bpmn:FormalExpression', {
          body: val
        });
        this.updateProperties({
          conditionExpression: newCondition
        });
      } else {
        this.updateProperties({
          conditionExpression: null
        });
      }
    },
    'formData.skipExpression': function formDataSkipExpression(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:skipExpression': val
      });
    }
  },
  created: function created() {
    var cache = (0, _parseElement.commonParse)(this.element);
    cache = (0, _parseElement.conditionExpressionParse)(cache);
    this.formData = cache;
  }
};